import axios from 'axios';
import api from '../../services/config';
import { STATUS_OK } from '../constants/api-status-codes';

const ORIGIN = window.location.origin;

const get = (url, params, headers = {}) =>
  axios
    .get(`${api.base}${url}`, {
      withCredentials: true,
      headers: {
        ...headers,
        'Access-Control-Allow-Origin': ORIGIN
      },
      params
    })
    .then(verifyResponse)
    .catch(handleErrors);

const post = (url, payload) =>
  axios
    .post(`${api.base}${url}`, payload)
    .then(verifyResponse);

const verifyResponse = res => {
  if (!res) return null;
  if (res.status !== STATUS_OK || !res.data) {
    console.log(`error fetching - status: ${res.status}`);
    return res.status;
  }
  return res.data;
};

const handleErrors = error => console.error(error);

export { get, post };
